import { render, staticRenderFns } from "./wxOpen.vue?vue&type=template&id=bbeab294&scoped=true&lang=html&"
import script from "./wxOpen.vue?vue&type=script&lang=js&"
export * from "./wxOpen.vue?vue&type=script&lang=js&"
import style0 from "./wxOpen.vue?vue&type=style&index=0&id=bbeab294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeab294",
  null
  
)

export default component.exports